/* eslint-disable no-unused-expressions */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
export var ShadowOverlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(51, 51, 51, 0.65);\n  z-index: ", ";\n"], ["\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(51, 51, 51, 0.65);\n  z-index: ", ";\n"])), function (props) { return props.zIndex; });
var propTypes = {
    shouldCloseOnBlur: PropTypes.bool,
    shouldOpenOnFocus: PropTypes.bool,
    zIndex: PropTypes.number,
    children: PropTypes.node,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
};
var ShadowEffect = function (_a) {
    var shouldCloseOnBlur = _a.shouldCloseOnBlur, shouldOpenOnFocus = _a.shouldOpenOnFocus, zIndex = _a.zIndex, children = _a.children, onClose = _a.onClose, onOpen = _a.onOpen, props = __rest(_a, ["shouldCloseOnBlur", "shouldOpenOnFocus", "zIndex", "children", "onClose", "onOpen"]);
    var _b = useState(false), isOpen = _b[0], setOpen = _b[1];
    var child = React.Children.only(children);
    function handleOpen() {
        onOpen && onOpen();
        setOpen(true);
    }
    function handleClose() {
        onClose && onClose();
        setOpen(false);
    }
    function handleKeyDown(evt) {
        var key = evt.key;
        if (key === 'Escape') {
            evt.preventDefault();
            handleClose();
        }
    }
    return (React.createElement(React.Fragment, null,
        isOpen && React.createElement(ShadowOverlay, __assign({ zIndex: zIndex, onClick: handleClose }, props)),
        React.cloneElement(child, {
            style: { position: 'relative', zIndex: isOpen && zIndex },
            onBlur: function () {
                var onBlur = child.props.onBlur;
                onBlur && onBlur();
                shouldCloseOnBlur && handleClose();
            },
            onClick: function () {
                var onClick = child.props.onClick;
                onClick && onClick();
                handleOpen();
            },
            onFocus: function () {
                var onFocus = child.props.onFocus;
                onFocus && onFocus();
                shouldOpenOnFocus && handleOpen();
            },
            onKeyDown: function (evt) {
                var onKeyDown = child.props.onKeyDown;
                onKeyDown && onKeyDown(evt);
                handleKeyDown(evt);
            },
        })));
};
ShadowEffect.propTypes = propTypes;
ShadowEffect.defaultProps = {
    zIndex: 10,
};
export default ShadowEffect;
var templateObject_1;
//# sourceMappingURL=ShadowEffect.js.map